import { render, staticRenderFns } from "./DictTypeModal.vue?vue&type=template&id=720a9ae2&scoped=true"
import script from "./DictTypeModal.vue?vue&type=script&lang=js"
export * from "./DictTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720a9ae2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('720a9ae2')) {
      api.createRecord('720a9ae2', component.options)
    } else {
      api.reload('720a9ae2', component.options)
    }
    module.hot.accept("./DictTypeModal.vue?vue&type=template&id=720a9ae2&scoped=true", function () {
      api.rerender('720a9ae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/DictTypeModal.vue"
export default component.exports